import { FC } from 'react';
import { useMediaQuery } from '@mantine/hooks';

import MobileLayout from './MobileLayout';
import DesktopLayout from './DesktopLayout';

const MapPage: FC = () => {
  // EIS-1069: resolve the media query synchronously on the first render. Mantine's default
  // (getInitialValueInEffect: true) returns undefined on the first render and only resolves
  // in a post-mount effect, so mobile-width viewports mounted <DesktopLayout> first and then
  // swapped to <MobileLayout> — mounting MapComponent (and its fetchPins POST) twice per
  // load. This app is client-rendered (CRA), so window.matchMedia is always available at
  // first render; Mantine still falls back to `false` if window were ever missing.
  const isMobile = useMediaQuery('(max-width: 1200px)', undefined, {
    getInitialValueInEffect: false,
  });

  if (isMobile) {
    return <MobileLayout />;
  }

  return <DesktopLayout />;
};

export default MapPage;
